import * as React from "react";
function SvgIcon1(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 33.045 33" {...props}><path d="M16.521.502L.843 14.802a.99.99 0 00.774 1.7h9.055v13.779a2.336 2.336 0 002.437 2.221h6.823a2.336 2.336 0 002.437-2.221V16.502h9.055a.99.99 0 00.774-1.7z" fill="none" stroke="#900" strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
export default SvgIcon1;